// src/hooks/useNalloChat.ts
import { useEffect } from 'react';

export const useNalloChatWidget = () => {
  useEffect(() => {
    const scriptId = 'nallo-chat-script';

    // Check if script already exists to avoid duplication
    if (document.getElementById(scriptId)) {
      return;
    }

    // Setup window.chatbotData
    const query = new URL(window.location.href).searchParams;
    const language = document.documentElement.lang ?? 'EN';
    const client_id = query.get('client_id') ?? 'magnolia';
    let env_work = 'preprod';

    if (document.location.origin?.match('https?://particuliers.engie.fr')) {
      env_work = 'prod';
    }

    const redirectUri = query.get('redirect_uri');
    let env_segment = 'residential';
    if (
      redirectUri?.startsWith('/fr/professionals') ||
      redirectUri?.startsWith('/nl/professionals')
    ) {
      env_segment = 'professionals';
    }

    const utms: Record<string, string> = {};
    query.forEach((value, key) => {
      if (key.startsWith('utm_')) utms[key] = value;
    });

    window.chatbotData = {
      env_work,
      env_language: language?.toUpperCase(),
      env_segment,
      client_id,
      ...utms,
      page_name: 'usermanagement.login',
      page_error: false,
    };

    // Set widget
    const baseUrl =
      env_work === 'prod'
        ? 'https://chatapi.n-allo.fr'
        : 'https://chatapi-acc.n-allo.fr';

    const cssId = 'nallo-chat-css';
    if (!document.getElementById(cssId)) {
      const link = document.createElement('link');
      link.id = cssId;
      link.rel = 'stylesheet';
      link.href = `${baseUrl}/V2/style.css`;
      document.head.appendChild(link);
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = `${baseUrl}/V2/bundle.js`;
    script.async = true;

    script.dataset.customerIdentifier = '8937844e-6c17-4aec-a73d-bb491f5d30dc';
    script.dataset.segment = 'ALL';
    script.dataset.language = 'fr';
    script.dataset.botName = 'LOGIN';
    script.dataset.customerFirstname = 'User';
    script.dataset.customerLastname = 'Anonymous';
    script.dataset.title = 'ENGIE Chat';

    document.head.appendChild(script);
  }, []);
};
